export default "__VITE_ASSET__DpOMD2k9__"